import { render } from "./ResetPasswordPopup.vue?vue&type=template&id=3068b3e0&scoped=true"
import script from "./ResetPasswordPopup.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPopup.vue?vue&type=script&lang=js"

import "./ResetPasswordPopup.vue?vue&type=style&index=0&id=3068b3e0&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3068b3e0"]])

export default __exports__